import React from 'react';
import './Highlight.scss';

interface HighlightProps {
  children: React.ReactNode | React.ReactNode[];
}

const Highlight: React.FC<HighlightProps> = ({ children }) => {
  return (
    <div className="mss-highlight">
      <span>
        <span className="mss-highlight__left" />
        <span className="mss-highlight__text">{children}</span>
        <span className="mss-highlight__right" />
      </span>
    </div>
  );
};

export default Highlight;
